const constants = {
    facebookUrl: 'https://www.facebook.com',
    twitterUrl: 'https://www.twitter.com',
    linkedInUrl: 'https://www.LinkedIn.com',
    applePodcastSubscriptionUrl: 'https://itunes.apple.com/us/podcast/complete-developer-podcast/id1039210992?mt=2&amp;ls=1',
    googlePodcastSubscriptionUrl: 'https://www.google.com/podcasts?feed=aHR0cHM6Ly9jb21wbGV0ZWRldmVsb3BlcnBvZGNhc3QuY29tL2ZlZWQvcG9kY2FzdC8',
    androidPodcastSubscriptionUrl: 'https://subscribeonandroid.com/completedeveloperpodcast.com/feed/podcast/',
    emailPodcastSubscriptionUrl: 'https://subscribebyemail.com/completedeveloperpodcast.com/feed/podcast/',
    baseUrl: 'https://next.completedeveloperpodcast.com',
    audioRoot: 'https://media.blubrry.com/completedeveloperpodcast/p/content.blubrry.com/completedeveloperpodcast/'
};

export default constants;